import React from 'react';
import AppButton from "@common/components/app-button";
import {CheckCircleIcon} from "@heroicons/react/24/solid";
import {useMediaQuery} from "react-responsive";
import {classNames} from "@utils/class-names";
import {useNavigate} from "react-router-dom";

interface PublicStickyCtaProps {
    onClick: () => void;
    onHidden: () => void;
    showText?: boolean;
}

const PublicStickyCta: React.FC<PublicStickyCtaProps> = ({onClick, showText, onHidden}) => {
    const isDesktop = useMediaQuery({minWidth: 1024});
    const navigate = useNavigate();

    const clickHandler = () => !isDesktop && onHidden();
    const handleRequirements = () => navigate("/article/visit-requirement");

    return (
        <div className="fixed bottom-0 left-0 right-0 bg-white/95 backdrop-blur border-t border-outline-mild z-30">
            <div className="max-w-[848px] mx-auto px-6 py-3 flex justify-center gap-x-4 gap-y-2 flex-wrap">
                {showText && (
                    <div
                        onClick={clickHandler}
                        className={classNames(
                            "flex items-center gap-2 rounded-full text-base border bg-white px-4 h-[48px]",
                            isDesktop ? "border-outline-mild text-on-surface/70" : "border-on-surface/30 border-[2px] text-on-surface font-semibold"
                        )}>
                        {isDesktop && <CheckCircleIcon className="w-5 h-5 text-primary"/>}
                        <span className="font-medium whitespace-nowrap">
                            {isDesktop ? "Panel polecanych specjalistów jest otwarty" : "Ukryj listę specjalistów"}
                        </span>
                    </div>
                )}
                <div className="flex gap-x-4 gap-y-2 flex-wrap justify-center">
                    {!showText && (
                        <AppButton
                            onClick={onClick}
                            label="Umów się do specjalisty"
                            className="bg-primary max-h-[48px] h-[48px] px-6 pt-2 text-on-primary font-semibold !text-base rounded-full hover:bg-primary/80"
                        />
                    )}
                    <AppButton
                        label="Co zabrać na wizytę?"
                        onClick={handleRequirements}
                        className={classNames(
                            "bg-transparent hover:bg-on-surface/5 h-12 w-fit px-5 rounded-full whitespace-nowrap",
                            "!text-base text-on-surface leading-5 font-semibold border-[2px] border-on-surface/30"
                        )}
                    />
                </div>
            </div>
        </div>
    );
};

export default PublicStickyCta;


